const images = {
  logo: require("../assets/images/logo.png"),
  logoBlack: require("../assets/images/logo_black.png"),
  toggleIcon: require("../assets/images/toggle.svg").default,
  toggleMobile: require("../assets/images/toggle-mobile.svg").default,
  email: require("../assets/images/email.svg").default,
  password: require("../assets/images/password.svg").default,
  nodata: require("../assets/images/nodata.gif").default,
  agentimge: require("../assets/images/agent-imge.png"),
  feedbackIcon: require("../assets/images/integrate/integrate-feedback.svg")
    .default,
  autoassignIcon: require("../assets/images/integrate/auto-assign.svg").default,
  reactjs: require("../assets/images/react-js-icon.svg").default,
  angularjs: require("../assets/images/angular-icon.svg").default,
  nextjsicon: require("../assets/images/nextjs-icon.svg").default,
  jqueryicon: require("../assets/images/jqueryicon.svg").default,
  phplogo: require("../assets/images/php-logo.svg").default,
  vuejs: require("../assets/images/vuejs.svg").default,
  jslogo: require("../assets/images/jslogo.svg").default,
  preactlogo: require("../assets/images/preact-seeklogo.svg").default,
  ios: require("../assets/images/ios.svg").default,
  android: require("../assets/images/android.svg").default,
  androidTv: require("../assets/images/Androidtv.svg").default,
  amazonTv: require("../assets/images/amazonTv.svg").default,
  appleTv: require("../assets/images/appletv.svg").default,
  samsungtv: require("../assets/images/sansungtv.svg").default,
  lgTv: require("../assets/images/lg.svg").default,
  tvprevattchsample: require("../assets/images/tvprevattchsample.png"),
  screenshotIcon: require("../assets/images/screenshot-icon.png"),
  success: require("../assets/images/success.png"),
  urlbg: require("../assets/images/urlbg.png"),
  taskbarbg: require("../assets/images/taskbarbg.png"),
  openTicketsIcon: require("../assets/images/open-tickets-icon.png"),
  attachmentIcon: require("../assets/images/attachment-icon.png"),
  botLogo: require("../assets/images/botLogo.jpeg"),
  defaultBotProfile: require("../assets/images/defaultbotImage.png"),
  qrCode: require("../assets/images/qrCode.png"),
  timeIcon: require("../assets/images/time-icon.png"),
  tvAgentRatingIcon: require("../assets/images/tv-agent-rating.svg").default,
  walkthrough: require("../assets/images/walkthrough.svg").default,
  html5Tv: require("../assets/images/html5.svg").default,
  googleLogo: require("../assets/images/integrate/integrate-google.svg")
    .default,
  jiraLogo: require("../assets/images/integrate/integrate-jira.svg").default,
  cuvoLogo: require("../assets/images/feedbackIcon.png"),
  zenDeskLogo: require("../assets/images/integrate/integrate-zendesk.svg")
    .default,
  broadpeakLogo: require("../assets/images/integrate/integrate-broadpeak.svg")
    .default,
  activeusers: require("../assets/images/activeusers.svg").default,
  opentickets: require("../assets/images/opentickets.svg").default,
  questanswers: require("../assets/images/questanswers.svg").default,
  chatbotlogo: require("../assets/images/chatbotLogo.svg").default,
  chatSendImg: require("../assets/images/chat-send.png"),
  chatbotSend: require("../assets/images/chat-send.svg").default,
  csvsvg: require("../assets/images/csv-svg.svg").default,
  xlsxsvg: require("../assets/images/xlsxsvg.svg").default,
  json: require("../assets/images/json.svg").default,
  noofsession: require("../assets/images/noofsession.svg").default,
  totalnomsg: require("../assets/images/totalnomsg.svg").default,
  botresolved: require("../assets/images/botresolved.svg").default,
  promptoraistkt: require("../assets/images/promptoraistkt.svg").default,
  noofticktraised: require("../assets/images/noofticktraised.svg").default,
  highpriority: require("../assets/images/highpriority.svg").default,
  lowpriority: require("../assets/images/lowpriority.svg").default,
  mediumpriority: require("../assets/images/mediumpriority.svg").default,
  ticketicon: require("../assets/images/ticketicon.svg").default,
  Alltickets: require("../assets/images/Alltickets.svg").default,
  newTickets: require("../assets/images/newTickets.svg").default,
  ActiveTickets: require("../assets/images/ActiveTickets.svg").default,
  ClosedTickets: require("../assets/images/ClosedTickets.svg").default,
  chatbotUSeAvatarIcon: require("../assets/images/chatbotUSeAvatarIcon.svg")
    .default,
};

export default images;
